import { Loader } from '../../../../components/loader/loader';
import { Page } from '../../../../components/page/page';
import { DeleteModal } from '../../../../features/delete-modal/delete-modal';
import { HasAccess } from '../../../../features/has-access/has-access';
import { RestoreModal } from '../../../../features/restore-modal/restore-modal';
import { TreeCards } from './tree-cards/tree-cards';
import { TreeControls } from './tree-controls/tree-controls';
import s from './tree-list.module.css';
import { TreeTable } from './tree-table/tree-table';
import { useTreeList } from './use-tree-list';

export const TreeList = () => {
  const { deleteTree, restoreTree, t, viewStyle, isLoadingFetch, list } = useTreeList();

  return (
    <Page className={s.page}>
      {isLoadingFetch && <Loader />}

      <h2 className={s.title}>
        {`${t('Деревья')} ${list?.length ? `(${list.length})` : ''}`}
        <TreeControls />
      </h2>

      <HasAccess service="tree" permissions={['write']}>
        <RestoreModal onSubmit={restoreTree} />
        <DeleteModal onSubmit={deleteTree} />
      </HasAccess>

      {viewStyle === 'table' ? <TreeTable /> : <TreeCards />}
    </Page>
  );
};
